<div class="flex flex-wrap gap-4 items-center p-4 bg-gray-50 rounded-lg">
  <div class="flex flex-col">
    <label for="dataInicial" class="block text-sm font-medium text-gray-700">Data Inicial</label>
    <input
      type="date"
      id="dataInicial"
      [(ngModel)]="dataInicial"
      (change)="onDataChange()"
      class="mt-1 block w-full md:w-auto p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>

  <div class="flex flex-col">
    <label for="dataFinal" class="block text-sm font-medium text-gray-700">Data Final</label>
    <input
      type="date"
      id="dataFinal"
      [(ngModel)]="dataFinal"
      (change)="onDataChange()"
      class="mt-1 block w-full md:w-auto p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
  <div class="flex flex-col">
    <label for="lancamento" class="block text-sm font-medium text-gray-700">Lançamento</label>
    <p-dropdown
      [options]="lancamentoOptions"
      [(ngModel)]="selectedLancamento"
      (onChange)="onFiltroChange()"
      placeholder="Selecione um lançamento"
      styleClass="w-full md:w-auto"
      [showClear]="true"
    ></p-dropdown>
  </div>

        <div class="flex items-end">
          <button
            (click)="limparFiltros()"
            class="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Limpar Filtros
          </button>
        </div>
  </div>

<form class="w-full md:w-1/2 mt-4 p-4 bg-white border rounded-lg shadow-sm flex flex-col md:flex-row gap-4 md:items-end" (ngSubmit)="cadastrar()" #livroCaixaForm="ngForm">
  <div class="flex flex-col flex-1">
    <label for="descricao" class="block text-sm font-medium text-gray-700">
      Descrição
    </label>
    <input
      type="text"
      id="descricao"
      [(ngModel)]="livroCaixa.descricao"
      name="descricao"
      required
      class="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>

  <div class="flex flex-col w-full md:w-32">
    <label for="valor" class="block text-sm font-medium text-gray-700">
      Valor
    </label>
    <input
      type="number"
      id="valor"
      [(ngModel)]="livroCaixa.valor"
      name="valor"
      step="0.01"
      required
      class="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>

  <div class="flex flex-col w-full md:w-32">
    <label for="tipoLancamento" class="block text-sm font-medium text-gray-700">
      Tipo
    </label>
    <select
      id="tipoLancamento"
      [(ngModel)]="livroCaixa.tipoLancamento"
      name="tipoLancamento"
      required
      class="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    >
      <option value="">Selecione</option>
      <option value="E">Entrada</option>
      <option value="S">Saída</option>
    </select>
  </div>

  <div>
    <button
      type="submit"
      class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      Lançar
    </button>
  </div>
</form>



  <div class="overflow-x-auto w-full space-y-4">
    <h2 class="text-xl font-semibold">Lançamentos do Caixa</h2>
    <p-table [value]="lancamentos" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Descrição</th>
          <th class="p-2 border-b text-left">Data</th>
          <th class="p-2 border-b text-left">Valor</th>
          <th class="p-2 border-b text-left">Tipo</th>
          <th class="p-2 border-b text-left">Usuário</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-l>
        <tr>
<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ l.id }}
</td>

<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ l.descricao }}
</td>

<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ l.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" : 'America/Sao_Paulo' }}
</td>


<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ l.valor | currency:'BRL' }}
</td>

<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ getTipoLancamentoLabel(l.tipoLancamento) }}
</td>

<td class="p-2 border-b"
    [ngClass]="{'bg-blue-200': isEntrada(l.tipoLancamento),
                'bg-red': !isEntrada(l.tipoLancamento)}">
  {{ getNomeUsuario(l.usuarioId) }}
</td>

        </tr>
      </ng-template>
    </p-table>


  <div class="mt-4 text-right">
    <p><strong>Total dos itens filtrados: {{ totalValorItens | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</strong></p>
  </div>
  </div>
